import PageContainer, { PageHeader } from "@/components/PageContainer";
import { FRAMEWORKS } from "@/data/content";

export default function Frameworks() {
  return (
    <PageContainer testid="frameworks-page">
      <PageHeader
        overline="Part II · Framework Stack"
        title="Nine evidence-based frameworks working in concert."
        subtitle="Each framework has a specific job in the patient's journey and a specific job in each staff member's daily work. When they run together, the effect is compounding."
      />

      <div className="card overflow-hidden mb-10" data-testid="frameworks-table">
        <table className="w-full text-sm">
          <thead className="bg-cream">
            <tr className="text-left text-ink-muted">
              <th className="p-4 font-medium">Framework</th>
              <th className="p-4 font-medium hidden md:table-cell">Origin</th>
              <th className="p-4 font-medium">One-sentence job</th>
              <th className="p-4 font-medium hidden lg:table-cell">Where it lives</th>
            </tr>
          </thead>
          <tbody>
            {FRAMEWORKS.map((f, i) => (
              <tr
                key={f.id}
                className={i > 0 ? "border-t border-line-soft" : ""}
                data-testid={`framework-row-${f.id}`}
              >
                <td className="p-4 align-top">
                  <div className="text-navy font-semibold">{f.name}</div>
                </td>
                <td className="p-4 align-top text-xs text-ink-muted hidden md:table-cell max-w-[220px]">
                  {f.origin}
                </td>
                <td className="p-4 align-top text-ink">{f.job}</td>
                <td className="p-4 align-top text-ink-muted text-xs hidden lg:table-cell max-w-[220px]">
                  {f.where}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="framework-cards">
        {FRAMEWORKS.map((f) => (
          <article key={f.id} className="card p-6" data-testid={`framework-card-${f.id}`}>
            <div className="overline mb-2">{f.origin.split(",")[0]}</div>
            <h3 className="text-navy text-lg font-semibold mb-3">{f.name}</h3>
            <p className="text-sm text-ink leading-relaxed mb-3">{f.job}</p>
            <div className="rule mb-3" />
            <div className="text-xs text-ink-muted uppercase tracking-wider mb-1">Where it lives</div>
            <div className="text-sm text-navy">{f.where}</div>
          </article>
        ))}
      </div>
    </PageContainer>
  );
}
